import {isNullOrEmpty} from './String';

import {Messages} from '@developers/i18n';

const PAGE_TITLE_SEPARATOR = ' | ';

interface MetadataContent {
  charset?: string;
  property?: string;
  content?: string;
  name?: string;
}

interface Metadata {
  title: string;
  meta: MetadataContent[];
}

export function getTitle(...segments: Array<string | null | undefined>): string {
  return segments
    .reverse()
    .filter((segment): segment is string => segment != null)
    .concat([Messages.COMMON_METADATA_TITLE_PREFIX])
    .join(PAGE_TITLE_SEPARATOR);
}

export function getMetaData(imageUrl?: string) {
  if (process.env.NODE_ENV !== 'production' && isNullOrEmpty(Messages.DEVELOPERS_METADATA_TITLE)) {
    throw new Error(`Missing title metadata.`);
  }

  const metaData: Metadata = {
    title: `Discord - ${Messages.DEVELOPERS_METADATA_TITLE}`,
    meta: [{charset: 'utf-8'}],
  };

  if (!isNullOrEmpty(Messages.DEVELOPERS_METADATA_OGTITLE)) {
    metaData.meta.push({
      property: 'og:title',
      content: Messages.DEVELOPERS_METADATA_OGTITLE,
    });
  }

  if (!isNullOrEmpty(Messages.DEVELOPERS_METADATA_DESCRIPTION)) {
    metaData.meta.push({
      property: 'og:description',
      content: Messages.DEVELOPERS_METADATA_DESCRIPTION,
    });
  }

  if (!isNullOrEmpty(imageUrl)) {
    metaData.meta.push({
      property: 'og:image',
      content: imageUrl,
    });
  }

  if (!isNullOrEmpty(Messages.DEVELOPERS_METADATA_DESCRIPTION)) {
    metaData.meta.push({
      name: 'description',
      content: Messages.DEVELOPERS_METADATA_DESCRIPTION,
    });
  }

  return metaData;
}
